import type { FC } from 'react';

import { Dialog, CommonDialogLayout } from '@wwe-portal/ui/components/dialog';

import successLogo from '@wwe-portal/ui/assets/images/common/payment-success.webp';

interface SuccessDialogProps {
  onClose?: () => void;
  open?: boolean;
  actionElement?: React.ReactNode;
}
export const SuccessDialog: FC<SuccessDialogProps> = ({
  onClose,
  open = true,
  actionElement,
}) => {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <CommonDialogLayout
        actionElement={actionElement}
        closable
        contentClass="w-[326px] px-[60px] rounded-5"
        dataId="SuccessDialog"
        descriptionElement={
          <div className="my-4">
            Your item will be sent to your in-game inbox
          </div>
        }
        imageElement={
          <div className="relative flex h-full w-full items-center justify-center">
            <div className="from-bgColor45 to-bgColor46 rounded-full bg-gradient-to-b p-1">
              <div className="bg-back200 rounded-full p-2">
                <img alt="success" height={76} src={successLogo} width={76} />
              </div>
            </div>
          </div>
        }
        layoutClass="px-0 2xl:px-0"
        onClose={onClose}
        titleElement={<div className="mt-6">New item gained!</div>}
      />
    </Dialog>
  );
};
